export const graphqlSubscriptionsQueries = {
	provisioningStatusQuery: `subscription ProvisioningStatus($orchestrationId: String!) {
        signup {
            signupProvisioningStatus(
                orchestrationId: $orchestrationId
            ) {
                orchestrationId
                provisionComplete
                cloudId
            }
        }
    }`,
};
